import React from "react";
import { Breadcrumb } from "../../../components/Breadcrumb";
import { NewButton, SaveButton } from "../../../components/Buttons";

export const MoneyTransfer = () => {
    document.title = "Pul transfer";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Distributorlar", value: "/expeditors" },
        { name: "Pul transfer", value: "/expeditors/moneytransfer", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Pul transfer</h2>
                    <p>
                        Sahibkar və distributorlar (ekspediter) arasında olan pul mübadiləsi, mədaxil və məxaric şəklində icra olunan əməliyyat nəticəsində
                        distributorların balansı formalaşır. Həmçinin, ümumi borca təsir etmədən distributorun balansını artırmaq üçün xərc maddəsi korrekt
                        seçilməlidir. <NewButton>Pul məxaric</NewButton> düyməsini sıxıb, açılan pəncərədə lazım olan xanaları doldurub <SaveButton /> düyməsini
                        sıxmaq lazımdır.
                        <br />
                        Nümunədə Komisyon satış ⮞ Pul transfer səhifəsinə keçid göstərilib.
                    </p>
                    <img src="/images/expeditors/moneytransfer.gif" alt="Pul transfer" />
                </article>
            </div>
        </div>
    );
};
